<div class="quality-rating-icon-wrapper" #qualityRatingIconRef
     *ngIf="triggerGroup && targetRegion"
     [ngClass]="showQualityIndication && triggersAreUseable ? 'show' : 'hidden'"
     [style.top]="targetRegion.y + 'px'"
     [style.left]="targetRegion.x + 'px'"
     [style.width]="targetRegion.width + 'px'"
     [style.height]="targetRegion.height + 'px'"
     [style.transform]="'rotate(' + targetRegion.rotation + 'deg)'">
  <div class="quality-rating-icon"
       [ngStyle] = "{
              'left': triggerGroup.left,
              'top': triggerGroup.top,
              'transform': 'translate('
                + triggerGroup.alignHorizontal
                + ', '
                + triggerGroup.alignVertical
                + ')'
              }"
       (click)="triggerClicked(triggerGroup.triggers[0].action)"
       #triggersRef>
    <div *ngIf="triggerGroup.triggers[0].icon.type === 'font'">
      <mat-icon class="trigger-icon"
                [style.transform]="'rotate(' + -targetRegion.rotation + 'deg)'"
      >{{triggerGroup.triggers[0].icon.value}}</mat-icon>
    </div>
    <div *ngIf="triggerGroup.triggers[0].icon.type === 'svg'">
      <mat-icon class="trigger-icon"
                [svgIcon]="triggerGroup.triggers[0].icon.value"
                [style.transform]="'rotate(' + -targetRegion.rotation + 'deg)'"
                title="{{ 'i18n.dialog.insufficientImageQuality.message' | translate }}"
      ></mat-icon>
    </div>
  </div>
</div>
<toast #toast></toast>



// WEBPACK FOOTER //
// ./src/app/collage-designer/stage/placeholder/overlays/quality-rating-icon/quality-rating-icon.component.html